<template>
    <div class="container">
        <div class="fruity">
            <div class="title">
                Burger Friday
            </div>
            <div class="spinner">
               <flashcards></flashcards>
            </div>
            <div class="base">
               <!-- <img v-bind:src="'/images/' + burgers.burger1" />-->
            </div>
        </div>
        <arm class="arm"></arm>
    </div>
</template>

<script>
    import arm from './arm'
    import flashcards from './flashcards'
    export default {
        name: 'Fruity',
        props: {
            msg: String
        },
        components: {
            'arm': arm,
            'flashcards': flashcards
        },
        data: function () {
            return {
                burgers: {
                    burger1: 'burger1.jpg'
                }
            }
        }
    };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

    .container {
        overflow: hidden;
    }
    .fruity {
        width: 90%;
        margin-left: 0;
        margin-right: 0;
        height: 95vh;
        margin: auto;
        margin-top: 0;
        margin-bottom: 0;
        border-radius: 25px 25px 10px 10px;
        border: 10px solid #ff6a00;
        -webkit-box-shadow: inset 0px 0px 40px 23px rgba(148,146,148,0.68);
        -moz-box-shadow: inset 0px 0px 40px 23px rgba(148,146,148,0.68);
        box-shadow: inset 0px 0px 40px 23px rgba(148,146,148,0.68);
        background: rgba(76,76,76,1);
       float: left;
       position: relative;
    }

    .title {
        background: rgba(76,76,76,1);
        background: -moz-linear-gradient(left, rgba(76,76,76,1) 0%, rgba(89,89,89,1) 12%, rgba(102,102,102,1) 25%, rgba(71,71,71,1) 39%, rgba(44,44,44,1) 50%, rgba(0,0,0,1) 51%, rgba(17,17,17,1) 60%, rgba(43,43,43,1) 76%, rgba(28,28,28,1) 91%, rgba(19,19,19,1) 100%);
        background: -webkit-gradient(left top, right top, color-stop(0%, rgba(76,76,76,1)), color-stop(12%, rgba(89,89,89,1)), color-stop(25%, rgba(102,102,102,1)), color-stop(39%, rgba(71,71,71,1)), color-stop(50%, rgba(44,44,44,1)), color-stop(51%, rgba(0,0,0,1)), color-stop(60%, rgba(17,17,17,1)), color-stop(76%, rgba(43,43,43,1)), color-stop(91%, rgba(28,28,28,1)), color-stop(100%, rgba(19,19,19,1)));
        background: -webkit-linear-gradient(left, rgba(76,76,76,1) 0%, rgba(89,89,89,1) 12%, rgba(102,102,102,1) 25%, rgba(71,71,71,1) 39%, rgba(44,44,44,1) 50%, rgba(0,0,0,1) 51%, rgba(17,17,17,1) 60%, rgba(43,43,43,1) 76%, rgba(28,28,28,1) 91%, rgba(19,19,19,1) 100%);
        background: -o-linear-gradient(left, rgba(76,76,76,1) 0%, rgba(89,89,89,1) 12%, rgba(102,102,102,1) 25%, rgba(71,71,71,1) 39%, rgba(44,44,44,1) 50%, rgba(0,0,0,1) 51%, rgba(17,17,17,1) 60%, rgba(43,43,43,1) 76%, rgba(28,28,28,1) 91%, rgba(19,19,19,1) 100%);
        background: -ms-linear-gradient(left, rgba(76,76,76,1) 0%, rgba(89,89,89,1) 12%, rgba(102,102,102,1) 25%, rgba(71,71,71,1) 39%, rgba(44,44,44,1) 50%, rgba(0,0,0,1) 51%, rgba(17,17,17,1) 60%, rgba(43,43,43,1) 76%, rgba(28,28,28,1) 91%, rgba(19,19,19,1) 100%);
        background: linear-gradient(to right, rgba(76,76,76,1) 0%, rgba(89,89,89,1) 12%, rgba(102,102,102,1) 25%, rgba(71,71,71,1) 39%, rgba(44,44,44,1) 50%, rgba(0,0,0,1) 51%, rgba(17,17,17,1) 60%, rgba(43,43,43,1) 76%, rgba(28,28,28,1) 91%, rgba(19,19,19,1) 100%);
        filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#4c4c4c', endColorstr='#131313', GradientType=1 );
        height: 12vh;
        border: 3px solid #097694;
        border-radius: 20px 20px 10px 10px;
        text-align: center;
        font-family: Impact, Charcoal, sans-serif;
        font-size: 45px;
        letter-spacing: 0px;
        word-spacing: 2px;
        color: #FFFFFF;
        background: #232323;
        text-shadow: 0 0 5px #FFF, 0 0 10px #FFF, 0 0 15px #FFF, 0 0 20px #49ff18, 0 0 30px #49FF18, 0 0 40px #49FF18, 0 0 55px #49FF18, 0 0 75px #49ff18;
        color: #FFFFFF;
        background: #232323;
        font-style: italic;
        font-variant: normal;
        text-transform: uppercase;
    }

    .spinner {
        height: 60vh;
        width: 100%;
        border: 1px solid red;
        box-sizing: border-box;
       ;
       
    }

    .base {
        height: 22vh;
        width: 100%;
        position: relative;
        box-sizing: border-box;
        border: 2px solid red;
        background-repeat: repeat-x;
        background-image: url("/images/burger1.jpg")
    }

        .base img {
            position: absolute;
            /*top: 0px;
            right: 0px;
            bottom: 0px;
            left: 0px;*/
            height: 100%;
            background-repeat: repeat-y;
        }


</style>


<style>
    html {
        background-color: #000;
       
    }

</style>
